export default __webpack_public_path__ + "static/media/dog.be4da73a.svg";